import nan from '../types/nan.js';
import infinity from '../types/infinity.js';
import NegativeInfinity from '../types/negative-infinity.js';

const specialNumbers = [
    nan,
    infinity,
    NegativeInfinity
];

export default specialNumbers;
